import { lazy } from "react";

const UnsubscribePage = lazy(() => import("./UnsubscribePage"));

export { UnsubscribePage };
